module.exports = __webpack_public_path__ + "img/ISO-pic1.dc2790e6.png";